import { makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  Avatar,
  Box,
  Divider,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  styled,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { REACT_URL_CARDTEMPLATE } from "../../actions/EndPoints";
import Com_logo from "../../assets/USA_Images/login_images/logo_mbl.svg";
import CustomTextfeild from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  addCardTemplate,
  getCardTemplateById,
  updateCardTemplate,
} from "../../slices/CardTemplate/CardTemplateSlice";
import { getAllVisitorType } from "../../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import LandscapeIcon from "./LandscapeIcon";
import PortraitIcon from "./PortraitIcon";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  marginTop: "-10px",
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: mode ? "#888B8D" : "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

const StyledBadge = styled(FormGroup)(({ theme }) => ({
  "& .MuiTypography-root": {
    left: "0px !important",
    position: "absolute",
  },
}));
const useStyles = makeStyles((theme) => ({
  title: {
    color: "#c4c4c4 !important",
    fontSize: "20px !important",
    fontWeight: "500 !important",
  },
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
}));

function AddCardTemplate(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { open, handleClose } = props;
  const [visitorData, setVisitorData] = useState([]);
  const { t } = useTranslation();
  const [visitorTypeId, setVisitorTypeId] = useState("");
  const [position, setPosition] = useState("Portrait");
  const { darkMode } = useContext(ThemeContext);
  const [state, setState] = React.useState({
    id: "",
    visitorTypeId: "",
    name: "",
    description: "",
    companyId: "",
    print: true,
    companyLogo: true,
    companyName: true,
    profile: true,
    firstName: true,
    lastName: false,
    mobile: true,
    email: true,
    visitorType: true,
    checkInTime: true,
    qrCode: true,
    visitorSign: true,
    checkOutTime: true,
    hostName: true,
    cardorientation: "",
  });

  const [error, setError] = useState({
    name: false,
    visitorTypeId: false,
    description: false,
  });

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    if (prevState !== undefined) {
      loadData();
    }
  }, []);

  useEffect(() => {
    loadVisitType();
  }, []);

  const prevState = props.history.location.state;
  const handleChangeDropdown = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handleChange1 = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const loadVisitType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getAllVisitorType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000" && data.data) {
          setVisitorData(data.data.visitorTypes);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadData = () => {
    dispatch(getCardTemplateById(prevState.data.id))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAE0096") {
          setPosition(data.data.cardorientation);
          setState({
            ...state,
            id: data.data.id,
            cardorientation: data.data.cardorientation,
            name: data.data.name,
            description: data.data.description,
            visitorTypeId: data.data.visitorTypeId,
            companyLogo: data.data.companyLogo,
            companyName: data.data.companyName,
            profile: data.data.profile,
            print: data.data.print,
            firstName: data.data.firstName,
            lastName: data.data.lastName,
            mobile: data.data.mobile,
            email: data.data.email,
            visitorType: data.data.visitorType,
            checkInTime: data.data.checkInTime,
            qrCode: data.data.qrCode,
            hostName: data.data.hostName,
            checkOutTime: data.data.checkOutTime,
            visitorSign: data.data.visitorSign,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(state.name)) {
      Toast(t("Enter Card Name"), "error");
      setError({ name: true });
      return;
    }
    if (CommonUtil.isEmptyString(state.visitorTypeId)) {
      Toast(t("Please select visitor type"), "error");
      setError({ visitorTypeId: true });
      return;
    }

    const dto = {
      id: state.id,
      visitorTypeId: state.visitorTypeId.id,
      name: state.name,
      description: state.description,
      companyId: state.companyId,
      print: state.print,
      companyLogo: state.companyLogo,
      companyName: state.companyName,
      profile: state.profile,
      firstName: state.firstName,
      lastName: state.lastName,
      mobile: state.mobile,
      email: state.email,
      visitorType: state.visitorType,
      checkInTime: state.checkInTime,
      qrCode: state.qrCode,
      visitorSign: state.visitorSign,
      hostName: state.hostName,
      checkOutTime: state.checkOutTime,
      cardorientation: state.cardorientation,
    };

    if (CommonUtil.isEmptyString(prevState)) {
      dispatch(addCardTemplate(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0028" && data.data) {
            Toast(data.message, "success");
            history.push({
              pathname: REACT_URL_CARDTEMPLATE,
              state: { ...data },
            });
            handleClose();
          } else {
            Toast(data.message, "error");
          }
        });
    } else {
      dispatch(updateCardTemplate(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0029") {
            Toast(t(data.message), "success");
            history.push({
              pathname: REACT_URL_CARDTEMPLATE,
              state: { ...data },
            });
          } else {
            Toast(t(data.message), "error");
          }
        });
    }
  };

  useEffect(() => {
    if (props.location.state) {
      setVisitorTypeId(
        visitorData.find((visitorType) => {
          return visitorType.id === props.location.state.data.visitorTypeId;
        })
      );
    }
  }, [visitorData?.length > 0]);

  useEffect(() => {
    if (props.location.state)
      setState({
        ...state,
        id: props.location.state.data.id,
        visitorTypeId: visitorTypeId,
        name: props.location.state.data.name,
        description: props.location.state.data.description,
        companyId: props.location.state.data.companyId,
        print: props.location.state.data.print,
        companyLogo: props.location.state.data.companyLogo,
        companyName: props.location.state.data.companyName,
        profile: props.location.state.data.profile,
        firstName: props.location.state.data.firstName,
        lastName: props.location.state.data.lastName,
        mobile: props.location.state.data.mobile,
        email: props.location.state.data.email,
        visitorType: props.location.state.data.visitorType,
        checkInTime: props.location.state.data.checkInTime,
        qrCode: props.location.state.data.qrCode,
        visitorSign: props.location.state.data.visitorSign,
        checkOutTime: props.location.state.data.checkOutTime,
        hostName: props.location.state.data.hostName,
        // cardorientation: props.location.state.cardorientation,
      });
  }, [!CommonUtil.isEmptyString(visitorTypeId)]);

  const [show, setShow] = useState();

  const handlePortrait = () => {
    setShow(false);
    setState({
      ...state,
      cardorientation: "Portrait",
    });
    setPosition("Portrait");
  };
  const handleLandscape = () => {
    setShow(true);
    setState({
      ...state,
      cardorientation: "Landscape",
    });
    setPosition("Landscape");
  };
  const cancel = (e) => {
    history.push(REACT_URL_CARDTEMPLATE);
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const calculateInitialHeight = () => {
    return window.innerHeight - 150;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;

      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  return (
    <>
      <HeaderToolbar
        title={state.id ? t("EDITTEMP") : t("ADDTEMP")}
        back_button={true}
      />
      <>
        <Box
          style={{
            padding: "0px",
            width: "100%",
            height: `${height}px`,
            overflowY: "auto",
            scrollbarWidth: "none",
            borderRadius: "10px",
            marginTop: "10px",
          }}
        >
          <div
            style={{
              flexGrow: 1,
              overflowY: "auto",
              height: "100%",
              overflowX: "hidden",
            }}
          >
            <Paper
              sx={{ p: 2 }}
              style={{ backgroundColor: darkMode ? "#0E2A41" : "" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CustomTextfeild
                    label={t("COMMON069")}
                    name={"name"}
                    value={state.name}
                    error={error.name}
                    handleChange={handleChange1}
                    type={"text"}
                    inputProps={{ className: classes.input, maxLength: 30 }}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    style={{ width: "100%" }}
                    noOptionsText={"No Options found"}
                    name="visitorTypeId"
                    value={state.visitorTypeId}
                    options={
                      CommonUtil.isEmptyArray(visitorData) ? [] : visitorData
                    }
                    getOptionLabel={(option) =>
                      option.name ? option.name : ""
                    }
                    onChange={(event, newValue) => {
                      if (!CommonUtil.isEmpty(newValue)) {
                        setState({ ...state, visitorTypeId: newValue });
                      } else {
                        setState({ ...state, visitorTypeId: "" });
                      }
                      setError({ visitorTypeId: false });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required={true}
                        name="visitorTypeId"
                        value={state.visitorTypeId}
                        error={error.visitorTypeId}
                        variant="outlined"
                        fullWidth
                        label={t("COMMON068")}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomTextfeild
                    label={t("ATYPE009")}
                    name="description"
                    value={state.description}
                    handleChange={handleChange1}
                    type={"text"}
                    inputProps={{ className: classes.input, maxLength: 250 }}
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </Paper>
            <Paper
              style={{
                backgroundColor: darkMode ? "#0E2A41" : "",
                marginTop: "10px",
              }}
            >
              <Grid style={{ display: "flex" }}>
                <Grid
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "50%", lg: "50%" },
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "30px",
                  }}
                >
                  <StyledBadge>
                    <FormControl component="fieldset" variant="standard">
                      <FormLabel
                        component="legend"
                        className={darkMode ? "labelTitle1" : "labelTitle"}
                      >
                        {t("COMPANYINFO")}
                      </FormLabel>
                      <FormGroup>
                        <Grid style={{ display: "flex" }}>
                          <Grid className="leftSwitch">
                            <FormLabel
                              component="legend"
                              className={darkMode ? "formLabel2" : "formLabel"}
                            >
                              {t("COMPANYINFO1")}
                            </FormLabel>
                            <Android12Switch
                              checked={state.companyLogo}
                              onChange={handleChange}
                              name="companyLogo"
                              mode={darkMode}
                            />
                          </Grid>
                          <Grid></Grid>
                        </Grid>
                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("VISUPDATE0006")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.companyName}
                            onChange={handleChange}
                            name="companyName"
                            mode={darkMode}
                          />
                        </Grid>
                      </FormGroup>
                      <FormLabel
                        component="legend"
                        className={darkMode ? "labelTitle1" : "labelTitle"}
                      >
                        {t("VISUPDATE0008")}
                      </FormLabel>
                      <FormGroup>
                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("USERPROFCARD002")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.profile}
                            onChange={handleChange}
                            name="profile"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("COMMON020")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.firstName}
                            onChange={handleChange}
                            name="firstName"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("COMMON021")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.lastName}
                            onChange={handleChange}
                            name="lastName"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("COMMON063")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.mobile}
                            onChange={handleChange}
                            name="mobile"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("VISUPDATE0001")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.email}
                            onChange={handleChange}
                            name="email"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("COMMON068")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.visitorType}
                            onChange={handleChange}
                            name="visitorType"
                            mode={darkMode}
                          />
                        </Grid>
                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("CheckInTime")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.checkInTime}
                            onChange={handleChange}
                            name="checkInTime"
                            mode={darkMode}
                          />
                        </Grid>
                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("QRCODE1")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.qrCode}
                            onChange={handleChange}
                            name="qrCode"
                            mode={darkMode}
                          />
                        </Grid>
                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("VIOSITORSIGN")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.visitorSign}
                            onChange={handleChange}
                            name="visitorSign"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("END_DATE_TIME")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.checkOutTime}
                            onChange={handleChange}
                            name="checkOutTime"
                            mode={darkMode}
                          />
                        </Grid>

                        <Grid className="leftSwitch">
                          <FormLabel
                            component="legend"
                            className={darkMode ? "formLabel2" : "formLabel"}
                          >
                            {t("HOST_NAME")}
                          </FormLabel>
                          <Android12Switch
                            checked={state.hostName}
                            onChange={handleChange}
                            name="hostName"
                            mode={darkMode}
                          />
                        </Grid>
                      </FormGroup>
                    </FormControl>
                  </StyledBadge>
                </Grid>

                <Divider
                  flexItem
                  orientation="vertical"
                  sx={{ mx: 0.5, my: 1 }}
                />
                <Grid
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "50%", lg: "50%" },
                  }}
                  style={{ padding: "24px" }}
                >
                  <Grid>
                    <Grid sx={{ textAlign: "end" }}>
                      <IconButton
                        className="scaleImage"
                        onClick={handlePortrait}
                      >
                        <PortraitIcon />
                      </IconButton>
                      <IconButton
                        className="scaleImage"
                        onClick={handleLandscape}
                      >
                        <LandscapeIcon />
                      </IconButton>
                    </Grid>

                    {position === "Portrait" ? (
                      <Paper
                        elevation={0}
                        style={{
                          height: "500px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: darkMode ? "#1A364E" : "",
                        }}
                      >
                        <Grid
                          className="id-Card"
                          sx={{ boxShadow: 1 }}
                          style={{ backgroundColor: "#0F5A9C1A" }}
                        >
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <Grid
                              className="avatarIcon"
                              sx={{
                                display: state.companyLogo ? "block" : "none",
                              }}
                            >
                              <Avatar alt="" src={Com_logo} />
                            </Grid>
                            <Grid
                              sx={{
                                display: state.companyName ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("VISUPDATE0006")}
                            </Grid>
                          </Grid>
                          <Grid>
                            <Grid
                              sx={{ display: state.profile ? "block" : "none" }}
                            >
                              <IconButton
                                className="ImageAvatar1"
                                variant="contained"
                                component="label"
                                color="secondary"
                              >
                                <Avatar
                                  className="ImageAvatar"
                                  alt=""
                                  src={""}
                                />
                              </IconButton>
                            </Grid>
                            <Grid style={{ display: "inline-flex" }}>
                              <Grid
                                sx={{
                                  display: state.firstName ? "block" : "none",
                                }}
                                className={
                                  darkMode ? "card_label5" : "card_label2"
                                }
                              >
                                {t("COMMON020")}
                              </Grid>{" "}
                              &nbsp;
                              <Grid
                                sx={{
                                  display: state.lastName ? "block" : "none",
                                }}
                                className={
                                  darkMode ? "card_label5" : "card_label2"
                                }
                              >
                                {t("COMMON021")}
                              </Grid>
                            </Grid>
                            <Grid
                              sx={{ display: state.mobile ? "block" : "none" }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("COMMON063")}
                            </Grid>
                            <Grid
                              sx={{ display: state.email ? "block" : "none" }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("VISUPDATE0001")}
                            </Grid>
                            <Grid
                              sx={{
                                display: state.visitorType ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("COMMON068")}
                            </Grid>
                            <Grid
                              sx={{
                                display: state.checkInTime ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label5" : "card_label2"
                              }
                            >
                              {t("CheckIn")}
                            </Grid>
                            <Grid
                              sx={{ display: state.qrCode ? "block" : "none" }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("QRCODE1")} {""}
                            </Grid>
                            <Grid
                              sx={{
                                display: state.visitorSign ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                              style={{
                                textAlign: "end",
                                bottom: 28,
                                position: "absolute",
                              }}
                            >
                              {t("Signature")} {""}
                            </Grid>

                            <Grid
                              sx={{
                                display: state.checkOutTime ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("END_DATE_TIME")}
                            </Grid>

                            <Grid
                              sx={{
                                display: state.hostName ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("HOST_NAME")}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    ) : (
                      <Paper
                        elevation={0}
                        style={{
                          height: "500px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: darkMode ? "#1A364E" : "",
                        }}
                      >
                        <Grid
                          className="id-CardHorizontal"
                          sx={{ boxShadow: 1 }}
                          style={{
                            backgroundColor: darkMode
                              ? "rgba(15, 90, 156, 0.1)"
                              : "#0F5A9C1A",
                          }}
                        >
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <Grid
                              className="avatarIcon"
                              sx={{
                                display: state.companyLogo ? "block" : "none",
                              }}
                            >
                              <Avatar alt="" src={Com_logo} />
                            </Grid>
                            <Grid
                              sx={{
                                display: state.companyName ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("VISUPDATE0006")}
                            </Grid>
                          </Grid>
                          <Grid>
                            <Grid
                              sx={{ display: state.profile ? "block" : "none" }}
                            >
                              <IconButton
                                className="ImageAvatar1"
                                variant="contained"
                                component="label"
                                color="secondary"
                              >
                                <Avatar
                                  className="ImageAvatar"
                                  alt=""
                                  src={""}
                                />
                              </IconButton>
                            </Grid>
                            <Grid style={{ display: "inline-flex" }}>
                              <Grid
                                sx={{
                                  display: state.firstName ? "block" : "none",
                                }}
                                className={
                                  darkMode ? "card_label5" : "card_label2"
                                }
                              >
                                {t("COMMON020")}
                              </Grid>{" "}
                              &nbsp;
                              <Grid
                                sx={{
                                  display: state.lastName ? "block" : "none",
                                }}
                                className={
                                  darkMode ? "card_label5" : "card_label2"
                                }
                              >
                                {t("COMMON021")}
                              </Grid>
                            </Grid>
                            <Grid
                              sx={{ display: state.mobile ? "block" : "none" }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("COMMON063")}
                            </Grid>
                            <Grid
                              sx={{ display: state.email ? "block" : "none" }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("VISUPDATE0001")}
                            </Grid>
                            <Grid
                              sx={{
                                display: state.visitorType ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("COMMON068")}
                            </Grid>
                            <Grid
                              sx={{
                                display: state.checkInTime ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label5" : "card_label2"
                              }
                            >
                              {t("CheckIn")}
                            </Grid>
                            <Grid
                              sx={{ display: state.qrCode ? "block" : "none" }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("QRCODE1")} {""}
                            </Grid>
                            <Grid style={{ display: "flex" }}>
                              <Grid
                                sx={{
                                  display: state.visitorSign ? "block" : "none",
                                }}
                                className={
                                  darkMode ? "card_label3" : "card_label"
                                }
                                style={{
                                  textAlign: "end",
                                  bottom: 28,
                                  position: "absolute",
                                }}
                              >
                                {t("Signature")} {""}
                              </Grid>
                            </Grid>

                            <Grid
                              sx={{
                                display: state.checkOutTime ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("END_DATE_TIME")}
                            </Grid>

                            <Grid
                              sx={{
                                display: state.hostName ? "block" : "none",
                              }}
                              className={
                                darkMode ? "card_label3" : "card_label"
                              }
                            >
                              {t("HOST_NAME")}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    )}
                  </Grid>
                  <Grid container xs={12} justifyContent="center" mt={2}>
                    <Grid item sx={{ ml: 2 }}>
                      <CancelButtons
                        color="secondary"
                        onClick={(e) => cancel()}
                        variant="contained"
                      >
                        <Typography>{t("COMMON008")}</Typography>
                      </CancelButtons>
                    </Grid>
                    {state.name === "Default" ? (
                      <Grid item sx={{ ml: 2 }}>
                        <SubmitButtons
                          disabled
                          onClick={handleSubmit}
                          variant="contained"
                        >
                          <Typography>{t("COMMON007")}</Typography>
                        </SubmitButtons>
                      </Grid>
                    ) : (
                      <Grid item sx={{ ml: 2 }}>
                        <SubmitButtons
                          onClick={handleSubmit}
                          variant="contained"
                        >
                          <Typography>{t("COMMON007")}</Typography>
                        </SubmitButtons>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </div>
        </Box>
      </>
    </>
  );
}
export default AddCardTemplate;
